<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />
    <!-- Breadcrumb y ayuda -->
    <div class="mb-3">
      <div class="row">
        <div class="col-11">
          <div class="breadcrumb-container">
            <router-link to="/MenuPrincipal">Inicio</router-link>
          </div>
        </div>
        <div class="col-1">
          <span
            class="material-symbols-outlined"
            style="font-size: 32px; color: blue; cursor: pointer"
            @click="showModalHelp = true"
            >help
          </span>
        </div>
      </div>
    </div>
    <!-- Area de notificación -->
    <!--     <div class="notification-area" v-for="(notificacion, index) in notificaciones" :key="index">
      <div class="notification-message"
        :class="{ 'is-success': notificacion.type === 'success', 'is-error': notificacion.type === 'error' }">
        {{ notificacion.message }}
      </div>
    </div> -->
    <hr />
    <!-- Modal -->
    <div class="modal-dialog modal-xl" style="z-index: 1">
      <div class="modal-content">
        <form>
          <div class="modal-body">
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idTipoIden" class="form-label fw-bold"> Tipo identificación</label>
                </div>
                <div class="col-2">
                  <select
                    class="form-select"
                    id="idTipoIden"
                    name="idTipoIden"
                    v-model="datoPersona.idTipoIden"
                  >
                    <option
                      v-for="tipoIden in tipoIdens"
                      :value="tipoIden.idTipoIden"
                      :key="tipoIden.idTipoIden"
                    >
                      {{ tipoIden.nombre }}
                    </option>
                  </select>
                </div>
                <div class="col-2">
                  <label for="documento" class="form-label fw-bold">Documento</label>
                </div>
                <div class="col-2">
                  <input
                    type="text"
                    class="form-control"
                    id="documento"
                    name="documento"
                    v-model="datoPersona.documento"
                    style="text-transform: uppercase"
                    @keydown="onKeydownSoloNumerosCedula"
                    @input="onInputLimpiarCedula"
                    required
                  />
                </div>
                <div class="col-2">
                  <label for="idEstadoCivil" class="form-label fw-bold">
                    Estado Civil</label
                  >
                </div>
                <div class="col-2">
                  <select
                    class="form-select"
                    id="idEstadoCivil"
                    name="idEstadoCivil"
                    v-model="datoPersona.idEstadoCivil"
                  >
                    <option
                      v-for="estadoCivil in estadoCivils"
                      :value="estadoCivil.idEstadoCivil"
                      :key="estadoCivil.idEstadoCivil"
                    >
                      {{ estadoCivil.nombre }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaNac" class="form-label fw-bold">Fecha Nacimiento</label>
                </div>
                <div class="col-2">
                  <input
                    type="date"
                    class="form-control"
                    id="fechaNac"
                    name="fechaNac"
                    v-model="formattedFechaNac"
                    required
                  />
                </div>
                <div class="col-2">
                  <label for="sexo" class="form-label fw-bold">Sexo</label>
                </div>
                <div class="col-2">
                  <select
                    class="form-select"
                    id="sexo"
                    name="sexo"
                    v-model="datoPersona.sexo"
                    required
                  >
                    <option value="">Seleccione el género</option>
                    <option value="M">Masculino</option>
                    <option value="F">Femenino</option>
                  </select>
                </div>
                <div class="col-2">
                  <label for="telefono" class="form-label fw-bold">Teléfono</label>
                </div>
                <div class="col-2">
                  <input
                    type="text"
                    class="form-control"
                    id="telefono"
                    name="telefono"
                    v-model="datoPersona.telefono"
                    style="text-transform: uppercase"
                    @keydown="onKeydownSoloNumerosMax10"
                    @input="onInputLimpiarTelefono"
                    required
                  />
                </div>
              </div>
            </div>
            <!-- Botón Lista de Valores  Tipo Iden -->
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="primerNombre" class="form-label fw-bold">Primer Nombre</label
                  >
                </div>
                <div class="col-4">
                  <input
                    type="text"
                    class="form-control"
                    id="primerNombre"
                    name="primerNombre"
                    v-model="datoPersona.primerNombre"
                    style="text-transform: uppercase"
                    @keydown="onKeydownBloquearNoLetras"
                    @input="onInputLimpiarNoLetras('primerNombre')"
                    required
                  />
                </div>
                <div class="col-2">
                  <label for="segundoNombre" class="form-label fw-bold">Segundo Nombre</label
                  >
                </div>
                <div class="col-4">
                  <input
                    type="text"
                    class="form-control"
                    id="segundoNombre"
                    name="segundoNombre"
                    v-model="datoPersona.segundoNombre"
                    style="text-transform: uppercase"
                    @keydown="onKeydownBloquearNoLetras"
                    @input="onInputLimpiarNoLetras('segundoNombre')"
                    required
                  />
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="primerApellido" class="form-label fw-bold">Primer Apellido</label
                  >
                </div>
                <div class="col-4">
                  <input
                    type="text"
                    class="form-control"
                    id="primerApellido"
                    name="primerApellido"
                    v-model="datoPersona.primerApellido"
                    style="text-transform: uppercase"
                    @keydown="onKeydownBloquearNoLetras"
                    @input="onInputLimpiarNoLetras('primerApellido')"
                    required
                  />
                </div>
                <div class="col-2">
                  <label for="segundoApellido" class="form-label fw-bold">Segundo Apellido</label
                  >
                </div>
                <div class="col-4">
                  <input
                    type="text"
                    class="form-control"
                    id="segundoApellido"
                    name="segundoApellido"
                    v-model="datoPersona.segundoApellido"
                    style="text-transform: uppercase"
                    @keydown="onKeydownBloquearNoLetras"
                    @input="onInputLimpiarNoLetras('segundoApellido')"
                    required
                  />
                </div>
              </div>
            </div>
            <!-- Botón Lista de Valores  Localidad -->
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idLocalidad" class="form-label fw-bold">Localidad</label>
                </div>
                <div class="col-4">
                  <select
                    class="form-select"
                    id="idLocalidad"
                    name="idLocalidad"
                    v-model="datoPersona.idLocalidad"
                  >
                    <option
                      v-for="localidad in localidads"
                      :value="localidad.idLocalidad"
                      :key="localidad.idLocalidad"
                    >
                      {{ localidad.nombre }}
                    </option>
                  </select>
                </div>
                <div class="col-2">
                  <label for="email" class="form-label fw-bold">Email</label>
                </div>
                <div class="col-4">
                  <input
                    type="text"
                    class="form-control"
                    id="email"
                    name="email"
                    v-model="datoPersona.email"
                    required
                  />
                </div>
              </div>
            </div>
            <!-- Botón Lista de Valores  Localidad -->
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="direccion" class="form-label fw-bold">Dirección</label>
                </div>
                <div class="col-10">
                  <input
                    type="text"
                    class="form-control"
                    id="direccion"
                    name="direccion"
                    v-model="datoPersona.direccion"
                    style="text-transform: uppercase"
                    required
                  />
                </div>
              </div>
            </div>
            <!--
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="tipoPersona" class="form-label">TipoPersona</label>
                </div>
                <div class="col-10">
                  <input type="text" class="form-control" id="tipoPersona" name="tipoPersona"
                    v-model="datoPersona.tipoPersona" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
-->
            <button @click.prevent="mostrarOcultarBloque">
              {{
                mostrarBloque ? "(-) Menos información" : "(+) Más información"
              }}
            </button>
            <div v-if="mostrarBloque" class="mb-3">
              <div class="mb-3" v-if="btnEditar">
                <div class="row">
                  <div class="col-2">
                    <label for="idPersona" class="form-label fw-bold">IdPersona</label>
                  </div>
                  <div class="col-4">
                    <span id="idPersona" class="form-control-plaintext">{{
                      datoPersona.idPersona
                    }}</span>
                  </div>
                  <div class="col-2">
                    <label for="fechaReg" class="form-label fw-bold">Fecha de registro</label
                    >
                  </div>
                  <div class="col-4">
                    <span id="fechaReg" class="form-control-plaintext">{{
                      getFormattedDateTime(datoPersona.fechaReg)
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
        <div class="modal-footer d-flex justify-content-between">
          <div>
            <button
              type="submit"
              class="btn btn-outline-primary"
              @click.prevent="actualizarPersona"
              v-if="btnEditar"
              title="Actualizar"
            >
              <i
                class="material-icons"
                style="font-size: 32px; color: blue; cursor: pointer"
                >update</i
              >Actualizar
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="tabs">
      <button
        class="tablink"
        @click="showTable = 'usuarios'"
        :class="{ 'active-tab': showTable === 'usuarios' }"
      >
        <i
          class="material-icons"
          style="font-size: 24px; color: red; cursor: pointer"
          >person_add</i
        >
        Usuario
      </button>
    </div>

    <div v-if="showTable === 'usuarios'">
      <PersonaUsuario
        :p_idPersona="p_idPersona"
        :p_email="datoPersona.email"
      ></PersonaUsuario>
    </div>

    <Footer />
  </div>
</template>
<script>
import config from '@/config';
import Layout from "@/components/Layout.vue";
import Footer from "@/components/Footer.vue";
import api from "@/services/api";
import { validarForm } from "@/modules/validacionesForms.js";
import dateFormat from "@/modules/dateFormat.js";
import PersonaUsuario from "../forms/PersonaUsuario.vue";


import * as $ from "jquery";
window["$"] = $;
window["jQuery"] = $;
import swal from "sweetalert";

import {
  bloquearNoLetras,
  limpiarNoLetras,
  bloquearSoloNumerosCedula,
  limpiarSoloNumerosCedula,
  bloquearSoloNumerosMax10,
  limpiarSoloNumerosMax10
} from '@/modules/validacionesFormularios.js';

export default {
  components: {
    Layout,
    Footer,
    PersonaUsuario,
  },
  data() {
    return {
      personas: [],
      datoPersona: {},
      nombreBusqueda: "",
      titulo: "",
      btnCrear: false,
      btnEditar: true,
      modalWindow: true,
      p_idPersona: 0,
      tipoIdens: [],
      localidads: [],
      estadoCivils: [],
      showTable: "medico",
      mostrarBloque: false,
      showNotifications: false,
      notificaciones: [],
      popupAyuda: false,
      modulo: 0,
      dataLoaded: false,
      showModalHelp: false,
    };
  },
  computed: {
    formattedFechaNac: {
      get() {
        if (!this.datoPersona.fechaNac) return "";
        const date = new Date(this.datoPersona.fechaNac);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
      },
      set(value) {
        const date = new Date(value);
        date.setMinutes(date.getMinutes() + date.getTimezoneOffset()); // Ajuste para zona horaria
        this.datoPersona.fechaNac = date.toISOString();
      },
    },
  },
  mounted() {
    this.p_idPersona = this.$route.params.p_idpersona;
    this.modulo = window.sessionStorage.getItem("modulo");
    this.getData();
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
    this.fetchTipoIdens();
    this.fetchLocalidads();
    this.fetchEstadoCivils();
  },
  methods: {
    getFormattedDateTime(date) {
      return dateFormat.getFormattedDateTime(date);
    },
    mostrarOcultarBloque() {
      this.mostrarBloque = !this.mostrarBloque;
    },

    getData() {
      api.get("/vwpersonas/" + this.p_idPersona)
        .then((response) => {
          this.datoPersona = response.data;
          this.dataLoaded = true;
        })
        .catch((error) => {
          console.error("Error al obtener datos de la persona:", error);
        });
    },
    validarPersona() {
      const requiredFields = [
        "idTipoIden",
        "idLocalidad",
        "idEstadoCivil",
        "documento",
        "primerNombre",
        "segundoNombre",
        "primerApellido",
        "segundoApellido",
        "fechaNac",
        "direccion",
        "telefono",
        "sexo",
        "email",
      ];
      const requiredFieldsText = [
        "idTipoIden",
        "idLocalidad",
        "idEstadoCivil",
        "documento",
        "primerNombre",
        "segundoNombre",
        "primerApellido",
        "segundoApellido",
        "fechaNac",
        "direccion",
        "telefono",
        "sexo",
        "email",
      ];
      return validarForm(this.datoPersona, requiredFields, requiredFieldsText);
    },
    async actualizarPersona() {
      if (this.validarPersona() === 1) {
        try {
          await api.post("/personas",
            this.datoPersona
          );
          //          $('#ventanaModal').modal('hide');
          swal("Correcto!", "Persona actualizada exitosamente!", "success");
          //            this.notificaciones.push({ message: "Persona creada exitosamente!", type: "success" });
          //          this.getDataPagina(this.paginaActual);
        } catch (error) {
          swal(
            "Error!",
            "Intentelo de nuevo!" + error.response.data.message,
            "error"
          );
          //          this.notificaciones.push({ message: "Intentelo de nuevo!"+error.response.data.message, type: "error" });
        }
      }
    },
    fetchTipoIdens() {
      fetch(config.apiBaseUrl + "/vwtipoidens")
        .then((response) => response.json())
        .then((data) => {
          this.tipoIdens = data;
        })
        .catch((error) => {
          console.error("Error fetching tipoIdens:", error);
        });
    },
    fetchLocalidads() {
      fetch(config.apiBaseUrl + "/vwlocalidads")
        .then((response) => response.json())
        .then((data) => {
          this.localidads = data;
        })
        .catch((error) => {
          console.error("Error fetching localidads:", error);
        });
    },
    fetchEstadoCivils() {
      fetch(config.apiBaseUrl + "/vwestadocivils")
        .then((response) => response.json())
        .then((data) => {
          this.estadoCivils = data;
        })
        .catch((error) => {
          console.error("Error fetching estadoCivils:", error);
        });
    },
    openHelp() {
      this.popupAyuda = true;
      this.$refs.helpPopup.open();
    },
    handlePopupClosed() {
      this.popupAyuda = false;
    },
    onKeydownBloquearNoLetras(e) {
      bloquearNoLetras(e);
    },
    onInputLimpiarNoLetras(campo) {
      // this[campo] es equivalente a this.primerNombre, this.segundoNombre, etc.
      this.datoPersona[campo] = limpiarNoLetras(this.datoPersona[campo]);
    },
    /**
     * Método local que envuelve bloquearSoloNumerosCedula,
     * pasando el evento y el valor actual de `datoPersona.documento`.
     */
    onKeydownSoloNumerosCedula(e) {
      bloquearSoloNumerosCedula(e, this.datoPersona.documento);
    },
    /**
     * Cada vez que el usuario escribe o pega en el campo,
     * limpiamos todo lo que no sea dígito y limitamos a 10 caracteres.
     */
    onInputLimpiarCedula() {
      this.datoPersona.documento = limpiarSoloNumerosCedula(
        this.datoPersona.documento
      );
      // Validamos longitud:
      this.errorCedula = this.datoPersona.documento.length !== 10;
    },
    /**
     * Envuelve la función de utilidades, pasando el evento y el valor actual.
     */
    onKeydownSoloNumerosMax10(e) {
      bloquearSoloNumerosMax10(e, this.datoPersona.telefono);
    },
    /**
     * Cada vez que el usuario escribe o pega en el campo,
     * limpiamos todo lo que no sean dígitos y limitamos a 10 caracteres.
     */
    onInputLimpiarTelefono() {
      this.datoPersona.telefono = limpiarSoloNumerosMax10(this.datoPersona.telefono);
      // Validamos longitud: máximo 10 dígitos
      this.errorTelefono = this.datoPersona.telefono.length > 10;
      // (Opcional) Si no quieres permitir más de 10 automáticamente,
      // la propia función `limpiarSoloNumerosMax10` ya corta a 10.
      // Entonces `errorTelefono` rara vez quedará en true, pero lo dejamos por si 
      // luego deseas mostrar un aviso cuando el usuario intente pegar >10 dígitos.
    }
  },
};
</script>
<style src="@/assets/css/tabs.css" scoped></style>
<style src="@/assets/css/alertas.css" scoped></style>
